"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveVehicleRequestSchema = void 0;
var _zod = require("zod");
const RemoveVehicleRequestSchema = exports.RemoveVehicleRequestSchema = _zod.z.object({
  model: _zod.z.string(),
  vehicleId: _zod.z.string(),
  year: _zod.z.string()
}).transform(function (_ref) {
  let {
    year,
    ...rest
  } = _ref;
  return {
    ...rest,
    modelYear: year,
    reason: "disposed"
  };
});